export default function FilterButton({ hide, setHide, level }) {
    return (
        <button onClick={setHide} className={`w-[200px]  rounded-xl h-[62px] ${hide ? "bg-yellow border-[3px] border-grey-darker" : "bg-grey border-[3px] border-yellow"} uppercase font-boogaloo text-xl `}>{hide ? "Afficher maitrise " : " Cacher maitrise " } {level}</button>
    )
}